export default "__VITE_ASSET__Bj8YgqRW__"